import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "../i18n";

const KEY = "cookie-consent"; // "all" | "essential"

const readConsent = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

// Shown on first visit. Analytics (PostHog, see public/index.html) only load after "Accept all".
const CookieConsent = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!readConsent()) {
      const id = setTimeout(() => setOpen(true), 400);
      return () => clearTimeout(id);
    }
    return undefined;
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch {
      /* storage unavailable: choice applies for this visit */
    }
    if (value === "all" && typeof window.__loadAnalytics === "function") window.__loadAnalytics();
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-labelledby="cookie-title"
      className="pop-in fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-xl rounded-3xl sm:inset-x-auto sm:start-5 sm:mx-0 sm:max-w-md border border-line bg-surface/95 p-5 shadow-2xl shadow-black/20 backdrop-blur-md sm:bottom-5 sm:p-6"
    >
      <div className="flex items-start gap-4">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-brand-soft text-brand">
          <Cookie size={20} />
        </span>
        <div className="min-w-0">
          <p id="cookie-title" className="font-semibold text-ink">
            {t("cookie.title")}
          </p>
          <p className="mt-1.5 text-sm leading-relaxed text-ink-2">
            {t("cookie.body")}{" "}
            <Link to="/privacy-policy" className="text-brand underline underline-offset-2">
              {t("cookie.policy")}
            </Link>
          </p>
        </div>
      </div>
      <div className="mt-5 flex flex-wrap justify-end gap-2.5">
        <button type="button" onClick={() => choose("essential")} className="btn btn-secondary btn-sm">
          {t("cookie.reject")}
        </button>
        <button type="button" onClick={() => choose("all")} className="btn btn-primary btn-sm">
          {t("cookie.accept")}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
